import { Theme } from "@amx/ux-twoui-theming";
import { HighContrastSelector, ILinkStyles, IPersonaStyles, IStackStyles } from "@fluentui/react";
import { ViewportType } from "../../../../shared/constants";
import { isSmallToLargeViewport } from "../../LeftNav";

export const profileContainerStyles = (viewport: ViewportType): IStackStyles => {
    return {
        root: {
            margin: isSmallToLargeViewport(viewport) ? "8px 10px 8px 10px" : "16px 10px 16px 10px",
            height: isSmallToLargeViewport(viewport) ? "28px" : "48px"
        }
    };
};

export const personaStyles = (viewport: ViewportType, theme: Theme, noInteraction: boolean = false): Partial<IPersonaStyles> => {
    const highlightStyle = {
        outline: noInteraction ? "" : `2px solid ${theme.palette.themePrimary}`,
        [HighContrastSelector]: {
            outline: noInteraction ? "" : "2px solid highlight"
        },
    };
    return {
        root: {
            width: isSmallToLargeViewport(viewport) ? "28px" : "48px",
            borderRadius: "50%",
            ":focus": highlightStyle,
            ":hover": highlightStyle,
            ":active": {
                ...highlightStyle,
                outline: noInteraction ? "" : `2px solid ${theme.palette.themeDark}`
            }
        }
    };
};

export const personaLinkStyles: ILinkStyles = {
    root: {
        ":hover": {
            textDecoration: "none"
        },
        ":active": {
            textDecoration: "none"
        },
        ":active:hover": {
            textDecoration: "none"
        }
    }
};

export const personaWrapperStyles = (isNavCollapsed: boolean): IStackStyles => {
    return {
        root: {
            marginRight: isNavCollapsed ? undefined : "8px"
        }
    };
};

export const profileInfoStyles = (theme: Theme, isPrimaryInfo: boolean, noInteraction: boolean = false): ILinkStyles => {
    const color = isPrimaryInfo ? theme.palette.neutralPrimary : theme.palette.neutralSecondary;
    const highlightStyle = {
        color: noInteraction ? color : theme.palette.themePrimary,
        [HighContrastSelector]: {
            color: noInteraction ? "buttontext" : "highlight"
        }
    };
    return {
        root: {
            width: "fit-content",
            ":hover": {
                textDecoration: "none"
            },
            ":active": {
                textDecoration: "none"
            },
            ":active:hover": {
                textDecoration: "none"
            },
            "h1, h2, span": {
                color: color,
                [HighContrastSelector]: {
                    color: "buttontext"
                },
                ":focus": highlightStyle,
                ":hover": highlightStyle,
                ":active": {
                    ...highlightStyle,
                    color: noInteraction ? color : theme.palette.themeDark
                }
            }
        }
    };
};
